import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export interface Label {
  id: string;
  name: string;
  color: string;
  count?: number;
}

interface LabelItemProps {
  label: Label;
  selected: boolean;
  onSelect: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  focused?: boolean;
  "data-index"?: number;
}

export const LabelItem = React.memo(function LabelItem({
  label,
  selected,
  onSelect,
  onKeyDown,
  focused = false,
  "data-index": dataIndex,
}: LabelItemProps) {
  return (
    <div
      role="option"
      aria-selected={selected}
      tabIndex={focused ? 0 : -1}
      data-index={dataIndex}
      onClick={onSelect}
      onKeyDown={onKeyDown}
      className={cn(
        "flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-2 text-sm outline-none",
        "hover:bg-accent hover:text-accent-foreground",
        "focus:bg-accent focus:text-accent-foreground",
        selected && "bg-accent/50"
      )}
    >
      <Check
        className={cn("h-4 w-4 shrink-0", selected ? "opacity-100" : "opacity-0")}
        aria-hidden
      />
      <div
        className="h-3 w-3 shrink-0 rounded-full border border-border"
        style={{ backgroundColor: label.color || "#94a3b8" }}
        aria-hidden
      />
      <span className="flex-1 truncate">{label.name}</span>
      {label.count != null && (
        <span className="text-muted-foreground text-xs tabular-nums">
          {label.count}
        </span>
      )}
    </div>
  );
});
